import cn from "classnames";

import { specificBlockOptions } from "@components/cmsBlocks/configs";
import Search from "@components/Search/Search";
import Editor from "@ui-kit/cms/Editor/Editor";
import Container from "@ui-kit/Container/Container";
import Divider from "@ui-kit/Divider/Divider";
import ThreeDModel from "@ui-kit/ThreeDModel/ThreeDModel";

import Background from "./Background";
import s from "./HeroBlock.module.scss";

const HeroBlock = ({ data, updateField, settings }) => {
  const {
    title = "",
    subTitle = "",
    blockBackgroundImage = "",
    blockBackgroundImageMobile = "",
  } = data;

  const {
    showSearch,
    titleType,
    subTitleType,
    backgroundOption,
    defaultRoute,
  } = settings.specific;

  const isTitlesEqual = titleType?.value === subTitleType?.value;

  const getTitleComponent = () => {
    switch (titleType?.value) {
      case specificBlockOptions.hero.titleType.options[0].value:
        return {
          Component: "h1",
          props: { className: s.h1 },
        };

      case specificBlockOptions.hero.titleType.options[1].value:
        return {
          Component: "h2",
          props: { className: s.h2 },
        };

      default:
        return { Component: null, props: {} };
    }
  };

  const getSubTitleComponent = () => {
    switch (subTitleType.value) {
      case specificBlockOptions.hero.subTitleType.options[0].value:
        return {
          Component: "h1",
          props: { "data-v2": true, className: s.h1 },
        };

      case specificBlockOptions.hero.subTitleType.options[1].value:
        return { Component: "h2", props: { "data-v2": true, className: s.h2 } };

      case specificBlockOptions.hero.subTitleType.options[2].value:
        return { Component: "p", props: { className: s.p } };

      case specificBlockOptions.hero.subTitleType.options[3].value:
        // SubTitleComponent = <div />; // TODO: select datepicker
        return { Component: "p", props: { className: s.date } };
      case specificBlockOptions.hero.subTitleType.options[4].value:
        return { Component: null, props: {} };

      default:
        return { Component: null, props: {} };
    }
  };

  const TitleComponent = getTitleComponent();
  let { Component, props } = getSubTitleComponent();

  return (
    <>
      <Container
        className={cn(s.container, showSearch.value && s.withSearch)}
        cursorNotice="Double click to edit banner"
      >
        <Background
          blockBackgroundImage={blockBackgroundImage}
          blockBackgroundImageMobile={blockBackgroundImageMobile}
          backgroundOption={backgroundOption}
        />
        <Container
          full={false}
          cursorNotice="Double click to edit banner"
          className={s.innerContainer}
        >
          {isTitlesEqual ? (
            <TitleComponent.Component
              {...TitleComponent.props}
              className={cn(TitleComponent.props.className, s.equal)}
            >
              <Editor field={{ title }} onChange={updateField} onlyText />
              <Editor
                field={{ subTitle }}
                onChange={updateField}
                onlyText
                data-v2
                asSpan
              />
            </TitleComponent.Component>
          ) : (
            <>
              {TitleComponent.Component && (
                <TitleComponent.Component {...TitleComponent.props}>
                  <Editor field={{ title }} onChange={updateField} onlyText />
                </TitleComponent.Component>
              )}
              {Component && (
                <Component {...props}>
                  <Editor
                    field={{ subTitle }}
                    onChange={updateField}
                    onlyText
                  />
                </Component>
              )}
            </>
          )}

          {showSearch.value && (
            <Search className={s.search} prefill={defaultRoute?.value} />
          )}
        </Container>
        <Divider absolute />
      </Container>
      {/* <Container> */}
      {/* <ThreeDModel modelSrc="/static/models/SUPERIOR-bus.glb" /> */}
      {/* <ThreeDModel modelSrc="https://dev-luxexpress.fra1.cdn.digitaloceanspaces.com/media/3d_models/SUPERIOR-bus.glb" /> */}
      {/* </Container> */}
    </>
  );
};

export default HeroBlock;
